<div class="flex flex-row items-center overflow-x-auto overflow-y-hidden bg-white dark:bg-gray-900 shadow">
    @for (item of navigation; track item.key) {
        @if (item.activeRouteResolver === activeRouteResolverStrategy.UseDirective) {
            <a
                [routerLink]="getRouterLink(item)"
                (click)="onNavigationElementClicked(item)"
                [routerLinkActiveOptions]="{
                    exact: !!item && !!item.useExactRoute,
                }"
                routerLinkActive="border-b-blue bg-gray-500 dark:bg-gray-800"
                class="py-1 px-2 flex flex-col justify-center text-black-900 dark:text-gray-200 border-b-4 border-b-black-200 border-r border-r-black-200 border-solid text-center flex-grow hover:bg-gray-500 dark:hover:bg-gray-700 last:border-r-0">
                <je-context-bar-navigation-badge
                    [item]="item"
                    [routerLinkActiveOptions]="{
                        exact: !!item && !!item.useExactRoute,
                    }"
                    routerLinkActive="text-black-900 dark:text-white"></je-context-bar-navigation-badge>

                <span
                    class="hidden xl:block text-sm whitespace-nowrap"
                    [routerLinkActiveOptions]="{
                        exact: !!item && !!item.useExactRoute,
                    }"
                    routerLinkActive="text-black-900 dark:text-white"
                    >{{ item.label | translate }}</span
                >
            </a>
        } @else if (item.activeRouteResolver === activeRouteResolverStrategy.UseSelectedKeySelector) {
            <a
                (click)="itemClicked(item)"
                class="py-1 px-2 flex flex-col justify-center text-black-900 dark:text-white border-b-4 border-r border-r-black-200 border-solid text-center flex-grow hover:bg-gray-500 dark:hover:bg-gray-700 last:border-r-0 cursor-pointer"
                [class]="(isItemSelected(item) | async) ? 'border-blue bg-gray-500 dark:bg-gray-800' : ''">
                <je-context-bar-navigation-badge [item]="item" [class]="(isItemSelected(item) | async) ? 'text-black' : ''"></je-context-bar-navigation-badge>

                <span class="hidden xl:block text-sm whitespace-nowrap" [class]="(isItemSelected(item) | async) ? 'text-black-900 dark:text-white' : ''">{{
                    item.label | translate
                }}</span>
            </a>
        }
    }
</div>
